import { useDispatch } from 'react-redux';
import { setModalAction } from '../../../../store/modal/factory';
import { ActiveModal } from '../../../enums/active-modal';

export function useViewModel() {
  const dispatch = useDispatch();

  const linkClickHandler = () => dispatch(setModalAction(ActiveModal.FEEDBACK));

  return { linkClickHandler };
}
